import { RootState } from 'editor/src/store/index';

const isPopupOpen = (state: RootState, popupName: string) => state.app.popup.open === popupName;

export default isPopupOpen;
